// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HSdi","title":"styles_title__1BpZK"};